import { Author } from '@natu/ui/Author';

import {
  getAssetFromStoryblok,
  resolveStoryblokStyles,
  sbEditable,
  type SBProps,
  type Spacing,
  type StoryblokAsset,
} from '../../../utils';

interface SBPersonCardProps {
  portrait?: StoryblokAsset;
  name?: string;
  position?: string;
  mbMobile?: Spacing;
  mbTablet?: Spacing;
  mbDesktop?: Spacing;
  mtMobile?: Spacing;
  mtTablet?: Spacing;
  mtDesktop?: Spacing;
}

export const SBPersonCard = ({ blok }: SBProps<SBPersonCardProps>) => {
  const { mbDesktop, mbMobile, mbTablet, mtDesktop, mtMobile, mtTablet, name, portrait, position } =
    blok;

  const className = resolveStoryblokStyles({
    mt: mtMobile,
    mtTablet,
    mtDesktop,
    mb: mbMobile,
    mbTablet,
    mbDesktop,
  });

  if (!portrait && !name && !position) return null;

  const resolvedImage = getAssetFromStoryblok(portrait);

  return (
    <Author
      className={className}
      image={resolvedImage}
      name={name}
      role={position}
      variant="person"
      {...sbEditable(blok)}
    />
  );
};
